import React from 'react';
import { Dialog, IconButton, Typography } from '@mui/material';
import { styled } from "@mui/material";
import { MODAL_CLOSE_ICON } from '../../../../utils/constants';
const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop) =>
    !['custompadding', 'customBorderRadius', 'customDialogStyles'].includes(prop),
})(({ theme, custompadding, customBorderRadius, customDialogStyles }) => ({
  '& .MuiDialog-paper': {
    ...customDialogStyles,
    padding: custompadding || '50px 30px 50px 55px',
    borderRadius: customBorderRadius || '15px',
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
}));

const HeaderTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Figtree-Bold',
  fontSize: '22px',
  color: '#404585',
  textAlign: 'center',
  marginBottom: '40px',
  marginRight: '15px'
}));

const SubHeaderTypography = styled(Typography)(({ theme }) => ({
  fontFamily: 'Figtree-Regular',
  fontSize: '16px',
  color: '#727484',
  textAlign: 'center',
  marginTop: '-35px',
  marginRight: '15px'
}));

const ModalNewUI = ({ open, onClose, enableCloseOnOutsideClick = true, custompadding, customDialogStyles = {}, subHeaderContent, customBorderRadius, headerContent, children }) => {
  return (
    <StyledDialog open={open} onClose={enableCloseOnOutsideClick && onClose} custompadding={custompadding} customBorderRadius={customBorderRadius} customDialogStyles={customDialogStyles}>
      <CloseButton onClick={onClose}>
        <img src={MODAL_CLOSE_ICON} width="10px" alt='closeIcon' />
      </CloseButton>
      {headerContent && <HeaderTypography className='!font-bold !text-size-14'>{headerContent}</HeaderTypography>}
      {subHeaderContent && <SubHeaderTypography className='!text-size-14'>{subHeaderContent}</SubHeaderTypography>}
      {children}
    </StyledDialog>
  );
};

export default ModalNewUI;
